// Tracciamento e-commerce PostHog (eventi Product Viewed, Product Added,
// Cart Viewed, Checkout Started).
//
// Era inline in snippets/posthog-ecommerce-tracking.liquid: 12.395 byte
// ripetuti in OGNI pagina e mai messi in cache. Spostato qui resta identico,
// ma viene servito dal CDN Shopify e scaricato una volta sola (PERF-02, #10).
//
// Nessun Liquid in questo file, ed è la ragione per cui lo spostamento è
// sicuro: il contenuto non dipende da dati di pagina. Se un domani servisse
// un valore dal tema, passalo con un data-attribute sul tag <script>, non
// reintroducendo Liquid qui.

(function () {
  if (window.__muffaproPosthogEcommerceTracking) return;
  window.__muffaproPosthogEcommerceTracking = true;

  var SOURCE = 'shopify_storefront_theme';
  var POSTHOG_TOKEN = 'phc_sLfig25zC6yrJhDbdms9SmH5FkxFDLkx7RCJ4KCviBew';
  var POSTHOG_CAPTURE_URL = 'https://eu.i.posthog.com/capture/';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var lastCartViewedAt = 0;
  var productViewedSent = false;

  function clean(obj) {
    Object.keys(obj || {}).forEach(function (key) {
      if (obj[key] === undefined || obj[key] === null || obj[key] === '') delete obj[key];
    });
    return obj;
  }

  function centsToMoney(value) {
    var n = Number(value || 0);
    return Number.isFinite(n) ? Math.round(n) / 100 : 0;
  }

  function parseMoneyFromText(text) {
    var match = String(text || '').match(/€\s*([0-9]+(?:[.,][0-9]{1,2})?)/);
    if (!match) return undefined;
    return Number(match[1].replace(',', '.'));
  }

  function getPosthog() {
    // Serve la libreria caricata, non lo stub: dallo stub non si leggono
    // distinct_id e session_id e l'evento partirebbe con un id casuale,
    // scollegato dal visitatore in PostHog (succede quando il consenso arriva
    // nella pagina e array.js è ancora in caricamento).
    var ph = window.posthog;
    return ph && typeof ph.capture === 'function' && typeof ph.get_distinct_id === 'function' ? ph : null;
  }

  function canTrack() {
    var ph = getPosthog();
    if (!ph) return false;
    // PRV-01 (#4): modello opt-in. Prima bastava non aver fatto opt-out, che è
    // il modello opposto a quello richiesto in UE: senza un consenso esplicito
    // non si traccia. Senza la Customer Privacy API non si traccia nemmeno.
    if (!consensoAnalytics()) return false;
    if (typeof ph.has_opted_out_capturing === 'function' && ph.has_opted_out_capturing()) return false;
    return true;
  }

  function consensoAnalytics() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    try {
      return cp.analyticsProcessingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  // L'API di Shopify ha risposto e il trattamento non è consentito (nessuna
  // scelta, rifiuto o revoca). Gli eventi avvenuti in questo stato si scartano:
  // non si accodano per inviarli dopo un eventuale consenso.
  function consensoNegato() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!cp && typeof cp.analyticsProcessingAllowed === 'function' && !consensoAnalytics();
  }

  function distinctId() {
    var ph = getPosthog();
    if (ph && typeof ph.get_distinct_id === 'function') return ph.get_distinct_id();
    try {
      var key = Object.keys(localStorage).find(function (k) { return /^ph_.*_posthog$/.test(k); });
      if (key) {
        var stored = JSON.parse(localStorage.getItem(key) || '{}');
        return stored.distinct_id || stored.$device_id;
      }
    } catch (e) {}
    return 'muffapro_anonymous_' + Math.random().toString(16).slice(2);
  }

  function sessionId() {
    var ph = getPosthog();
    return ph && typeof ph.get_session_id === 'function' ? ph.get_session_id() : undefined;
  }

  function directCapture(eventName, props) {
    if (!canTrack()) return false;
    var properties = clean(Object.assign({
      distinct_id: distinctId(),
      source: SOURCE,
      $current_url: window.location.href,
      $pathname: window.location.pathname,
      $session_id: sessionId(),
      $lib: 'muffapro-theme-ecommerce'
    }, props || {}));
    var payload = JSON.stringify({
      api_key: POSTHOG_TOKEN,
      event: eventName,
      properties: properties
    });
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'application/json' });
        if (navigator.sendBeacon(POSTHOG_CAPTURE_URL, blob)) return true;
      }
    } catch (e) {}
    if (nativeFetch) {
      try {
        nativeFetch(POSTHOG_CAPTURE_URL, {
          method: 'POST',
          body: payload,
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          mode: 'cors',
          credentials: 'omit'
        }).catch(function () {});
        return true;
      } catch (e) {}
    }
    return false;
  }

  function capture(eventName, props, attempt) {
    attempt = attempt || 0;
    if (consensoNegato()) return;
    if (directCapture(eventName, props)) return;
    if (attempt < 240) setTimeout(function () { capture(eventName, props, attempt + 1); }, 250);
  }

  function productMeta() {
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || window.meta || {};
    var product = meta.product || {};
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var formVariantId = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var selectedVariantId = String(meta.selectedVariantId || (formVariantId && formVariantId.value) || '');
    var variant = variants.find(function (v) { return String(v.id) === selectedVariantId; }) || variants[0] || {};
    var titleEl = document.querySelector('main h1, h1');

    return clean({
      product_id: product.id ? String(product.id) : undefined,
      product_gid: product.gid,
      handle: product.handle,
      title: product.title || (titleEl && titleEl.textContent.trim()) || variant.name,
      vendor: product.vendor,
      product_type: product.type,
      variant_id: variant.id ? String(variant.id) : selectedVariantId,
      variant_title: variant.public_title || variant.name,
      sku: variant.sku,
      price: centsToMoney(variant.price),
      currency: meta.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      page_path: window.location.pathname,
      current_url: window.location.href
    });
  }

  function cartProduct(item) {
    return clean({
      product_id: item.product_id ? String(item.product_id) : undefined,
      variant_id: item.variant_id ? String(item.variant_id) : (item.id ? String(item.id) : undefined),
      handle: item.handle,
      title: item.product_title || item.title,
      variant_title: item.variant_title,
      sku: item.sku,
      quantity: Number(item.quantity || 1),
      price: centsToMoney(item.final_price || item.price),
      line_price: centsToMoney(item.final_line_price || item.line_price)
    });
  }

  function readCart() {
    if (!nativeFetch) return Promise.resolve(null);
    return nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function cartProps(cart, extra) {
    cart = cart || {};
    var items = Array.isArray(cart.items) ? cart.items : [];
    return clean(Object.assign({
      cart_token: cart.token,
      cart_value: centsToMoney(cart.total_price),
      currency: cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      items_count: Number(cart.item_count || items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0)),
      products: items.map(cartProduct)
    }, extra || {}));
  }

  function captureProductViewed(attempt) {
    attempt = attempt || 0;
    if (productViewedSent) return;
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || window.meta || {};
    if (!meta.page || meta.page.pageType !== 'product') return;
    // Senza consenso ci si ferma: se arriva dopo, riparte da visitorConsentCollected.
    if (consensoNegato()) return;
    var props = productMeta();
    props.$insert_id = ['mp_product_viewed', sessionId() || distinctId(), props.product_id, props.variant_id, window.location.pathname].join('_');
    productViewedSent = directCapture('Product Viewed', props);
    // Attesa limitata (60 s) dell'API di consenso e di array.js: prima il
    // tentativo ogni 250 ms non aveva fine.
    if (!productViewedSent && attempt < 240) setTimeout(function () { captureProductViewed(attempt + 1); }, 250);
  }

  function captureProductAdded(data, trigger) {
    if (consensoNegato()) return;
    var item = data && Array.isArray(data.items) ? data.items[0] : data;
    readCart().then(function (cart) {
      var props = Object.assign({}, productMeta(), item ? cartProduct(item) : {}, cartProps(cart, {
        trigger: trigger || 'cart_add',
        $insert_id: ['mp_product_added', Date.now(), Math.random().toString(16).slice(2)].join('_')
      }));
      capture('Product Added', props);
      captureCartViewed('cart_add_drawer');
    });
  }

  function captureCartViewed(trigger) {
    if (consensoNegato()) return;
    var now = Date.now();
    if (now - lastCartViewedAt < 5000) return;
    lastCartViewedAt = now;
    readCart().then(function (cart) {
      capture('Cart Viewed', cartProps(cart, {
        trigger: trigger || 'cart_view',
        page_path: window.location.pathname,
        current_url: window.location.href,
        $insert_id: ['mp_cart_viewed', Date.now(), Math.random().toString(16).slice(2)].join('_')
      }));
    });
  }

  function captureCheckoutStarted(label) {
    capture('Checkout Started', {
      trigger: 'checkout_click',
      checkout_label: label,
      cart_value: parseMoneyFromText(label),
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      page_path: window.location.pathname,
      current_url: window.location.href,
      $insert_id: ['mp_checkout_started', Date.now(), Math.random().toString(16).slice(2)].join('_')
    });
  }

  if (nativeFetch) {
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartAdd = /\/cart\/add(?:\.js)?/i.test(url);
      var responsePromise = nativeFetch.apply(this, arguments);
      if (!isCartAdd) return responsePromise;
      return responsePromise.then(function (response) {
        if (response && response.ok) {
          response.clone().json().then(function (data) {
            captureProductAdded(data, 'fetch_cart_add');
          }).catch(function () {
            captureProductAdded(null, 'fetch_cart_add_no_json');
          });
        }
        return response;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__muffaproUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (/\/cart\/add(?:\.js)?/i.test(String(xhr.__muffaproUrl || ''))) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            var data = null;
            try { data = JSON.parse(xhr.responseText); } catch (e) {}
            captureProductAdded(data, 'xhr_cart_add');
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('a,button') : null;
    if (!el) return;
    var label = (el.innerText || el.getAttribute('aria-label') || el.getAttribute('href') || '').trim();
    var href = el.getAttribute('href') || '';
    if (/vai al checkout|checkout|check-out/i.test(label + ' ' + href)) {
      captureCheckoutStarted(label || href);
    }
    if (/carrello/i.test(label) || /\/cart(?:$|\?)/.test(href)) {
      setTimeout(function () { captureCartViewed('cart_icon_click'); }, 300);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    captureProductViewed();
    if (window.location.pathname === '/cart') captureCartViewed('cart_page_load');
  });

  // Consenso dato nel banner mentre si è già sulla pagina: la vista prodotto
  // (o carrello) di questa pagina parte da qui. Con un rifiuto non succede nulla.
  document.addEventListener('visitorConsentCollected', function () {
    captureProductViewed();
    if (window.location.pathname === '/cart') captureCartViewed('cart_page_load');
  });

  captureProductViewed();
  if (window.location.pathname === '/cart') captureCartViewed('cart_page_load');
})();
